import List from "@material-ui/core/List";
import { dateTimeFormater } from "../../../../../utilities/formaters";
import ListingItem from "../../LisingItem";

const ApplicationGeneralInfoList = ({ application }) => {
  const lineStyle = { float: "left", whiteSpace: "normal", marginLeft: "20px" };

  return (
    <div style={lineStyle}>
      <ListingItem primaryText={"General"} />
      <div>
        <List>
          <ListingItem
            primaryText={application.IsPep ? "yes" : "no"}
            secondaryText="PEP answer"
          />
          <ListingItem
            primaryText={
              application.LoanBroker ? application.LoanBroker : "N/A"
            }
            secondaryText="Broker"
          />
          <ListingItem
            primaryText={
              application.ExpiredAt
                ? dateTimeFormater(application.ExpiredAt)
                : "No"
            }
            secondaryText="Expired"
          />
        </List>
      </div>
    </div>
  );
};

export default ApplicationGeneralInfoList;
